export const createPose = (pose) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    await firestore.collection('poses').add({
      ...pose
    })
    dispatch({
      type: 'CREATE_POSE',
      pose: pose
    })
  }
}

export const getPoseById = (id) => {
  return async (dispatch, getState, { getFirestore }) => {
    let pose
    try {
      const firestore = getFirestore();
      const poseRef = firestore.collection('poses').doc(id);
      pose = (await poseRef.get()).data();
    } catch (error) {
      console.error(error)
    }
    dispatch({
      type: 'GET_POSE_BY_ID',
      pose
    })
  }
}

export const editPose = (id, pose) => {
  return async (dispatch, getState, { getFirestore }) => {
    let newPose
    try {
      console.log(id)
      const firestore = getFirestore();
      const poseById = firestore.collection('poses').doc(id);
      newPose = (await poseById.update(pose))
    } catch (error) {
      console.log(error)
    }
    dispatch({
      type: 'UPDATE_POSE',
      newPose
    })
  }
}

export const deletePose = (id) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    await firestore.collection('poses').doc(id).delete()
    dispatch({
      type: 'DELETE_POSE',
      id: id
    })
  }
}